(ns ui.view.entity-graph.components.node
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [common.localization :as loc]
            [common.schema.entities.graph-reference :as gref]
            [ui.state.session.sub :as session-sub]
            [ui.util :as uu]
            [ui.view.entity-graph.model :as m]
            [ui.view.entity-graph.utils :as utils]
            [reagent-flow.core :as flow]))

(defn node-will-be-hidden?
  [ctx id]
  @(r/track contains? (:hide-nodes @(rf/subscribe [m/preview-show-hide ctx])) id))

(defn node-will-appear?
  [ctx id]
  @(r/track contains? (:show-nodes @(rf/subscribe [m/preview-show-hide ctx])) id))

(defn target-connected?
  [ctx map-profile-id target-handle-id]
  (let [target-handles-by-id @(rf/subscribe [m/target-handles-by-id ctx])]
    (boolean (get-in target-handles-by-id [map-profile-id target-handle-id]))))

(defn company-node
  [{is-connectable :isConnectable
    :keys [id selected data]}]
  (let [data (js->clj data :keywordize-keys true)
        ctx (:ctx data)
        ;; wasn't always working properly:
        ctx {:main-entity-id (or (:main-entity-id ctx)
                                 (:mainEntityId ctx))}
        map-profile-id (parse-long id)
        {:graph-entity/keys [label
                             entity-type
                             pep?] :as map-profile} (utils/get-entity map-profile-id)
        main-map-profile-id @(rf/subscribe [m/main-map-profile-id ctx])
        main? (= map-profile-id main-map-profile-id)
        highlight-pep? @(rf/subscribe [m/highlight-pep? ctx])
        reconnecting? (:reconnecting data)
        handle-style (merge
                      {}
                      (when reconnecting?
                        {:width "12px"
                         :height "12px"}))
        handle-classes (uu/cm
                        "w-3 h-3 border border-solid border-base-light-border bg-white"
                        (when reconnecting?
                          "outline-4 outline-offset-2 w-4 h-4 "))
        source-handle-classes "invisible"
        connected-target-classes (uu/cm
                                  "connected bg-black")
        fund? (contains? #{:entity.type/fof-asset
                           :entity.type/fund} entity-type)
        graph-entity-type (:entity/type map-profile)
        icon (get m/graph-icons graph-entity-type)
        show-icon? @(rf/subscribe [m/show-icons? ctx])
        title (str label
                   (when main?
                     "*"))]
    [:div
     {:class (uu/cm "custom-react-flow-node")}
     [:div
      {:class-name (uu/cm
                    "custom-node flex items-center justify-start overflow-hidden"
                    ;;TODO only when creating a connection via dragging
                    (when true
                      "select-none")
                    (if selected
                      "bg-complement-gloomy border-complement-gloomy-border text-complement-gloomy-text"
                      "bg-complement-light border-base-light-border")
                    (when main?
                      "bg-base-light")
                    (when (and selected main?)
                      "bg-complement-gloomy"))
       #_#_:on-context-menu
         (fn [_]
           (prn ">right-click"))
       :style (merge
               {:border-radius "4px"
                :height (let [base-height m/HEIGHT]
                          base-height)
                :width (let [base-width m/WIDTH]
                         base-width)
                :padding "8px"
                :background-style (if selected
                                    "complement-gloomy"
                                    "base-gloomy")
                :border-width "1px"
                :border-style (if selected
                                "solid"
                                "solid")}
               (when (node-will-be-hidden? ctx map-profile-id)
                 {:color "transparent"
                  :text-shadow "0 0 3px rgba(0,0,0,0.7)"})
               (when (node-will-appear? ctx map-profile-id)
                 {:background-color "red"})
               (when (= entity-type :entity.type/person)
                 {:border-radius "4px"})
               (when fund?
                 {:border-radius "4px"
                  :border-width "1px"}))}
      [:div
       {:title label
        :class      (uu/cm
                     "flex gap-2")}
       [:span
        [:i
         {:class (uu/cm "fal"
                        icon
                        (when-not show-icon?
                          "invisible"))}]]
       [:div
        {:class      (uu/cm
                      "line-clamp-2 break-words font-semibold"
                      (when main?
                        "font-bold break-normal"))}
        title]]
      (when (and pep? highlight-pep?)
        [:div
         {:class (uu/cm "absolute bottom-1 right-2"
                        "rounded-full px-2"
                        "bg-secondary-light")}
         (loc/tr :pep-highlight)])
      ;; target-handles:
      [flow/handle {:type :target
                    :class (uu/cm handle-classes
                                  (when @(r/track target-connected?
                                                  ctx map-profile-id :top)
                                    connected-target-classes))
                    :style handle-style
                    :position :top
                    :id "top-target-handle"
                    :is-connectable is-connectable}]
      [flow/handle {:type :target
                    :class (uu/cm handle-classes
                                  (when @(r/track target-connected?
                                                  ctx map-profile-id :left)
                                    connected-target-classes))
                    :style handle-style
                    :position :left
                    :id "left-target-handle"
                    :is-connectable is-connectable}]
      [flow/handle {:type :target
                    :class (uu/cm handle-classes
                                  (when @(r/track target-connected?
                                                  ctx map-profile-id :right)
                                    connected-target-classes))
                    :style handle-style
                    :position :right
                    :id "right-target-handle"
                    :is-connectable is-connectable}]
      [flow/handle {:type :target
                    :class (uu/cm handle-classes
                                  (when @(r/track target-connected?
                                                  ctx map-profile-id :bottom)
                                    connected-target-classes))
                    :style handle-style
                    :position :bottom
                    :id "bottom-target-handle"
                    :is-connectable is-connectable}]
      ;; note: source-handles later in order for draggable connect to
      ;;  start from source->target
      ;; source-handles:
      [flow/handle {:type :source
                    :class (uu/cm handle-classes
                                  source-handle-classes)
                    :style handle-style
                    :position :bottom
                    :id "bottom-source-handle"
                    :is-connectable is-connectable}]
      [flow/handle {:type :source
                    :class (uu/cm handle-classes
                                  source-handle-classes)
                    :style handle-style
                    :position :right
                    :id "right-source-handle"
                    :is-connectable is-connectable}]
      [flow/handle {:type :source
                    :class (uu/cm handle-classes
                                  source-handle-classes)
                    :style handle-style
                    :position :left
                    :id "left-source-handle"
                    :is-connectable is-connectable}]
      [flow/handle {:type :source
                    :class (uu/cm handle-classes
                                  source-handle-classes)
                    :style handle-style
                    :position :top
                    :id "top-source-handle"
                    :is-connectable is-connectable}]]]))

(defn annotation-node
  [{:keys [data]}]
  (let [data (js->clj data :keywordize-keys true)]
    ;;TODO allow hiding?
    [:<>
     (:label data)]))

(def person-node company-node)

(def fund-node company-node)

(defn action-items
  [ctx map-profile]
  (let [{:graph-entity/keys [entity-type]} map-profile
        map-profile-id (:db/id map-profile)
        allowed (get gref/connectors-by-entity-type entity-type)]
    (for [[connector-type dirs] allowed
          dir dirs]
      {:id (str connector-type dir)
       :label (get-in gref/create-gref-label [connector-type dir])
       :on-select! (fn [_]
                     (rf/dispatch [m/close-node-menu ctx])
                     (rf/dispatch [m/start-create-connector
                                   (assoc ctx
                                          :map-profile-id map-profile-id
                                          :connector-type connector-type
                                          :direction dir)]))
       :connector-type connector-type
       :dir dir})))

(defn action-view
  [_ctx {:keys [on-select! label]}]
  [:div
   {:class (uu/cm "p-2"
                  "cursor-pointer hover:bg-base-regular rounded")
    :on-click on-select!}
   label])

(defn context-menu
  [ctx]
  (let [{:keys [top left open? map-profile-id]} @(rf/subscribe [m/node-menu ctx])]
    (when open?
      (let [map-profile @(rf/subscribe [::session-sub/entity map-profile-id])
            actions (action-items ctx map-profile)]
        [:div
         {:id "node-context-menu"
          :class "flex flex-col gap-1 bg-base-light border border-base-light-border-paler border-solid p-3 absolute rounded"
          :style
          {:top top
           :left left
           :z-index 30}
          :on-key-down (fn [e]
                         (let [key-code (.-keyCode e)]
                           (when (= key-code 27)
                             (rf/dispatch [m/close-node-menu ctx]))))
          :tab-index 0
          :ref (fn [^js ref]
                 (when ref
                   (.focus ref)))}
         [:div
          {:class "flex justify-end"}]
         (doall
          (for [{:keys [id] :as action} actions]
            ^{:key (str id)}
            [action-view ctx action]))]))))
